import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { environment } from '@b2b/env/environment';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { User } from '@sparro/app/core/models/user.model';

@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.scss']
})
export class PeopleComponent implements OnInit {
  modules: any = [];
  compSlug: string;
  peopleSlug: string;
  isLoading: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private detailService: CompDetailService,
    public imageOptimizer: ImageOptimizerService
  ) {
  }

  ngOnInit(): void {
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.peopleSlug = this.route.snapshot.params.people_slug;
    this.getPeopleModule();
  }

  ngDoCheck(): void {
    if (this.peopleSlug !== this.route.snapshot.params.people_slug) {
      this.peopleSlug = this.route.snapshot.params.people_slug;
      this.getPeopleModule();
    }
  }

  getPeopleModule(): void {
    this.isLoading = true;
    this.detailService.peopleModule(this.compSlug, this.peopleSlug).subscribe(
      (response: any) => {
        this.modules = response;
        this.updateMetaInfo(this.modules[0]);
        this.modules[0].people?.map((people) => {
          people.show = false;
          people.has_short_desc = Boolean(people.desc.length <= 210);
        });
        this.isLoading = false;
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      });
  }

  updateMetaInfo(module): void {
    this.detailService.fetchCompetition(this.compSlug, (competition) => {
      let metaInfo: MetaDefinition[] = [];

      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | ${this.peopleSlug.charAt(0).toUpperCase()
        + this.peopleSlug.slice(1)}`;
      const description = `${this.peopleSlug.charAt(0).toUpperCase() + this.peopleSlug.slice(1)} of ${competition.title} competition |
        ${module.people ? module.people.map(people => ' ' + people.user.first_name + ' ' + people.user.last_name + ' ' +
        people.bio ) : ' '}`;
      const image = competition.image ?  this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  showDesc(index: number): void {
    this.modules[0].people[index].show = !this.modules[0].people[index].show;
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }

  getProfileUrl(user: User): string {
    return `${environment.profileUrl}${user.username}/`;
  }
}
